import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/shop',
            name: 'village_shop',
            component: () => import("./views/shop.vue"),
            meta: {
            }
        },
        {
            path: '/village/shop/:categoryIdentifier',
            name: 'village_categoryOffers',
            component: () => import("@/views/network/shop/views/categoryOffers.vue"),
            meta: {
                hideSaldo: true,
            }
        },
        {
            path: '/village/shop/singleOffer/:offerIdentifier',
            name: 'village_singleOffer',
            component: () => import("@/views/network/shop/views/categoryOffers.vue"),
        },
        {
            path: '/village/shop/upsellOffers/:parentOfferIdentifier',
            name: 'village_upsellOffers',
            component: () => import("@/views/network/shop/views/categoryOffers.vue"),
        },
        {
            path: '/village/shop/buy/:offerIdentifier',
            name: 'village_buyOffer',
            component: () => import("@/views/network/shop/views/buyOffer.vue"),
            meta: {
                hideSaldo: true,
            }
        },
        {
            path: '/village/shop/thankyou/:isDeferred/:isEntryOffer',
            name: 'village_thankyou',
            component: () => import("@/views/network/shop/views/thankyou.vue"),
            meta: {
                hideSaldo: true,
            }
        },
    ];
};